var exports = {
  "Z": "x9245d464--ba9228--layout",
};

module.exports = exports;
